import { useGetUpcomingInvoicesQuery } from "@/services/dashboard";

const useUpcomingInvoices = () => {
  const { data, error, isLoading } = useGetUpcomingInvoicesQuery();

  return {
    upcomingInvoices: data?.data?.items || [],
    isLoading,
    error,
  };
};

export default useUpcomingInvoices;
